export const API_URL = 'https://80ala1muig.execute-api.us-east-1.amazonaws.com/dev/';

export const GOOGLE_CLIENT_IDS = {
  dev: '223233671218-mujcmkmt5plupe2c5piurpvp1h435pgu.apps.googleusercontent.com',
  prod: '223233671218-f0csil399er4e27jqchlfg9ka3au3er7.apps.googleusercontent.com'
};